import {
  Component,
  ViewEncapsulation,
  OnInit,
  ViewChild,
  AfterViewInit,
  ViewChildren,
  QueryList,
  ViewContainerRef,
  HostListener,
  OnDestroy,
  ComponentRef,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Menu } from '@grapecity/wijmo.input';
import { KYMW1200Model } from './kymw1200.model';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import {
  FlexGrid,
  CellType,
  Row,
  AllowMerging,
  CellRange,
  CellRangeEventArgs,
  AllowDragging,
  HeadersVisibility,
} from '@grapecity/wijmo.grid';
import { TransposedGrid } from '@grapecity/wijmo.grid.transposed';
import { WjTransposedGrid } from '@grapecity/wijmo.angular2.grid.transposed';
import { EventArgs, hasClass, hidePopup, Point, showPopup } from '@grapecity/wijmo';
import { DataGridUtil } from '../../../commons/kymw00/data-grid-util';
import { FlexGridFilter, FilterType } from '@grapecity/wijmo.grid.filter';
import { PlessAlert } from 'src/app/shared/pless-alert/pless-alert.component';
import { GetBuyerSelectItemsService } from './api-services/get-buyer-select-items.service';
import { GetCycleDispConditionService } from './api-services/get-cycle-disp-condition.service';
import { GetCycleItemInfoService } from './api-services/get-cycle-item-info.service';
import { GetCycleMediumSelectItemsService } from './api-services/get-cycle-medium-select-items.service';
import { GetCycleSummaryDiffService } from './api-services/get-cycle-summary-diff.service';
import { GetCycleSummaryService } from './api-services/get-cycle-summary.service';
import { GetNonFixedOrderListService } from './api-services/get-non-fixed-order-list.service';
import { GetOtherMediumsService } from './api-services/get-other-mediums.service';
import { GetBuyerCodeForAgentService } from './api-services/get-buyer-code-for-agent.service';
import { RegistCycleDispConditionService } from './api-services/regist-cycle-disp-condition.service';
import { RegistCycleItemInfoService } from './api-services/regist-cycle-item-info.service';
import { RegistCycleSortService } from './api-services/regist-cycle-sort.service';
import { RegistWkResultListService } from './api-services/regist-wk-result-list.service';
import { GetCodeListService } from '../../../commons/kymw02/api-services/get-code-list.service';
import { GetOrderListService } from '../../../commons/kymw02/api-services/get-order-list.service';
import { GetCoopListService } from '../../../commons/kymw02/api-services/get-coop-list.service';
import { OutputCycleItemInfoService } from './api-services/output-cycle-item-info.service';
import { FileDownloadConfirmService } from '../../../commons/kymw02/file-download-confirm/file-download-confirm.service';
import { CatalogInfo } from './vo/catalog-info.model';
import { KYMW1203Component } from '../kymw1203/kymw1203.component';
import { KYMW1202Component } from '../kymw1202/kymw1202.component';
import { KYMW0800Component } from '../../../commons/kymw08/kymw0800/kymw0800.component';
import { KYMW0800InputModel } from '../../../commons/kymw08/kymw0800/vo/kymw0800-input.model';
import { KYMW1100Component } from '../../kymw11/kymw1100/kymw1100.component';
import { VersatileComboBoxComponent } from '../../../commons/kymw02/combo-box/versatile-combo-box/versatile-combo-box.component';
import { ItemInfo } from './vo/item-info.model';
import { KYMW2000Component } from '../../kymw20/kymw2000/kymw2000.component';
import { KYMW2000InputModel } from '../../kymw20/kymw2000/vo/kymw2000-input.model';
import { GetStaffBuyerSelectItemsService } from './api-services/get-staff-buyer-select-items.service';
import { GetUserColumnWidthSettingsService } from '../../../commons/kymw02/api-services/get-user-column-width-settings.service';
import { RegistUserColumnWidthSettingsService } from '../../../commons/kymw02/api-services/regist-user-column-width-settings.service';
import { KYMW1204Component } from '../kymw1204/kymw1204.component';
import { KYMW1204InputModel } from '../kymw1204/vo/kymw1204-input.model';
import * as wjInput from '@grapecity/wijmo.input';
import {PRICE_PATTERN_LIST} from './kymw1200.constants';
import { KYMW1205Component } from '../kymw1205/kymw1205.component';
import { CanDeactivateType } from '../../../shared/utils/leave-confirm.guard';
import { Subject } from 'rxjs';

/**
 * サイクル設定画面を管理するクラス
 *
 * @export KYMW1200Component
 * @class KYMW1200Component
 */
@Component({
  selector: 'app-kymw1200',
  templateUrl: 'kymw1200.component.html',
  styleUrls: ['kymw1200.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class KYMW1200Component
  extends PlessViewHelperSub
  implements OnInit, AfterViewInit, OnDestroy
{
  public model: KYMW1200Model = new KYMW1200Model();
  private dragIndex: number;
  private context: Menu;
  private subwindow: Window;
  public disableRadioOrderCode = false;

  // サブウィンドウ パス
  private static readonly SUBWINDOW_PATH = '/subwindow';
  // 表示情報切替 コード区分値
  private static readonly SWITCH_TYPE_CODE_DIV = 'ctp203';
  // 部門長 区分値
  private static readonly USER_CLASS_LEADER = '0';
  // 取引先 区分値
  private static readonly ASSOCIATED_USER_TYPE_SUPPLIER = KYMW00Model.ASSOCIATED_USER_TYPE_SUPPLIER;
  // 受注コードTo 初期値用
  private static readonly INIT_ORDER_TO_INDEX = 19;
  // 受注コード 最大週数
  private static readonly ORDER_SPAN_MAX = 52;
  // メモ 最大文字列長
  private static readonly MEMO_LENGTH_MAX = 200;
  // 企画回別情報 前の列数
  private static readonly CATALOG_FRONT_COLS = 26;
  // 企画回別情報 後の列数
  private static readonly CATALOG_BACK_COLS = 2;
  // 正規表現 特集 表紙
  private static readonly REGEX_FEATURE_COVER = /H1$/;
  // 正規表現 特集 裏表紙
  private static readonly REGEX_FEATURE_BACK_COVER = /H2$/;

  // 媒体・生協用 ALL
  public static readonly SELECT_ITEM_ALL_NAME = 'ALL';
  public static readonly SELECT_ITEM_ALL_VALUE = 'ALL';

  // 他媒体の選定状況要確認 媒体区分(EC専用・在庫限定)
  public static readonly MEDIUM_LIST_TO_CHECK_OTHERS = ['018', '026'];

  private static readonly FILE_NAME_PREFIX = 'サイクル設定一覧表';
  private static readonly FILE_NAME_DELIMITER = '_';
  private static readonly FILE_NAME_SUFFIX = '.xlsx';

  // 予実表 ヘッダー選択項目
  public static readonly HEADER_SELECT_ITEMS = [
    { val: '0', dsp: '計画数／予算' },
    { val: '1', dsp: '実績／予算' },
    { val: '2', dsp: '予算／前年実績' },
    { val: '3', dsp: '実績値／計画数' },
    { val: '4', dsp: '計画数／前年実績' },
    { val: '5', dsp: '実績値／前年実績' },
  ];

  // 列ピッカーの作成
  public columnPicker;

  /** 表示ボタン用バリデーション */
  private readonly validationsForDisplay: {
    invalid: (m: KYMW1200Model) => boolean;
    code: string;
    messages: string[];
  }[] = [
    {
      invalid: m => PlessViewUtilsSub.isEmpty(m.mediumType),
      code: 'E0103',
      messages: ['媒体'],
    },
    {
      invalid: m => PlessViewUtilsSub.isEmpty(m.buyerCode),
      code: 'E0103',
      messages: ['バイヤー'],
    },
    {
      invalid: m => PlessViewUtilsSub.isEmpty(m.coopCode),
      code: 'E0103',
      messages: ['表示生協'],
    },
    {
      invalid: m => PlessViewUtilsSub.isEmpty(m.orderCodeFrom),
      code: 'W0001',
      messages: ['表示受注コード'],
    },
    {
      invalid: m => m.orderCodeTo && m.orderCodeFrom > m.orderCodeTo,
      code: 'W0024',
      messages: ['表示受注コード'],
    },
    {
      invalid: m =>
        m.orderCodeTo &&
        m.orderCodeList.filter(
          _ => m.orderCodeFrom <= _.OrderCode && m.orderCodeTo >= _.OrderCode
        ).length > KYMW1200Component.ORDER_SPAN_MAX,
      code: 'W0031',
      messages: ['表示受注コード', KYMW1200Component.ORDER_SPAN_MAX + '週'],
    },
    {
      invalid: m => PlessViewUtilsSub.isEmpty(m.catalogIdFrom),
      code: 'W0001',
      messages: ['表示企画回'],
    },
    {
      invalid: m => m.orderCodeTo && PlessViewUtilsSub.isEmpty(m.catalogIdTo),
      code: 'W0024',
      messages: ['表示企画回'],
    },
  ];

  @ViewChild('dtg_Main', { static: false }) dtg_Main: FlexGrid;
  @ViewChild('dtg_Summary', { static: false }) dtg_Summary: TransposedGrid;
  @ViewChild('fltr_Main', { static: false }) fltr_Main: FlexGridFilter;
  @ViewChildren(VersatileComboBoxComponent)
  cmbs: QueryList<VersatileComboBoxComponent>;

  /** サブウィンドウ用 処理 */
  @HostListener('window:message', ['$event']) windowMessage(e) {
    if (
      window.location.origin === e.origin &&
      e.data?.kymw1001Model?.loginUserInfo?.UserID
    ) {
      this.sharedModel = e.data;
    }
  }
  @HostListener('window:beforeunload', []) windowBeforeunload() {
    if (this.subwindow) this.subwindow.close();
  }

  constructor(
    private dialogService: PlessDialogServiceSub,
    private getBuyerSelectItemsService: GetBuyerSelectItemsService,
    private getCycleDispConditionService: GetCycleDispConditionService,
    private getCycleItemInfoService: GetCycleItemInfoService,
    private getCycleMediumSelectItemsService: GetCycleMediumSelectItemsService,
    private getCycleSummaryDiffService: GetCycleSummaryDiffService,
    private getCycleSummaryService: GetCycleSummaryService,
    private getNonFixedOrderListService: GetNonFixedOrderListService,
    private getOtherMediumsService: GetOtherMediumsService,
    private getBuyerCodeForAgentService: GetBuyerCodeForAgentService,
    private registCycleDispConditionService: RegistCycleDispConditionService,
    private registCycleItemInfoService: RegistCycleItemInfoService,
    private registCycleSortService: RegistCycleSortService,
    private registWkResultListService: RegistWkResultListService,
    private getCodeListService: GetCodeListService,
    private getOrderListService: GetOrderListService,
    private getCoopListService: GetCoopListService,
    private outputCycleItemInfoService: OutputCycleItemInfoService,
    private fileDownloadConfirmService: FileDownloadConfirmService,
    private getStaffBuyerSelectItemsService: GetStaffBuyerSelectItemsService,
    private getUserColumnWidthSettingsService: GetUserColumnWidthSettingsService,
    private registUserColumnWidthSettingsService: RegistUserColumnWidthSettingsService,
    private route: ActivatedRoute,
    private router: Router,
    private kymw00Model: KYMW00Model,
    public viewContainerRef: ViewContainerRef
  ) {
    super(kymw00Model);
  }

  /**
   * コンポーネント初期化
   *
   * @memberof KYMW1200Component
   */
  public ngOnInit(): void {
    if (
      window.opener?.location.origin === window.location.origin &&
      KYMW1200Component.SUBWINDOW_PATH + window.opener?.location.pathname ===
        window.location.pathname
    ) {
      // 過去サイクル サブウィンドウ用処理
      window.opener?.postMessage(window.location.pathname);
      // バイヤーコード取得判定のため表示モードを指定
      this.model.displayMode = KYMW1200Model.DISPLAY_MODE_PAST;
    } else {
      this.componentName = 'KYMW1200';
    }

    // バイヤーコード取得
    if (!this.model.isPast) {
      if (this.sharedModel.kymw1001Model?.loginUserInfo.BuyerCodeList.length > 0) {
        this.model.userBuyerCodeList =
          this.sharedModel.kymw1001Model.loginUserInfo.BuyerCodeList;
        this.initSettings();
      } else {
        this.getBuyerCodeForAgentService.execute(this.model, () =>
          this.initSettings()
        );
      }
    } else {
      // 呼び出し元画面と同じバイヤーコードを取得
      window.addEventListener('load', () => {
        window.opener?.postMessage('buyerReady', '*');
        window.addEventListener('message', e => {
          // Chromeの拡張機能によっては延々にメッセージを送りつけてくるので回避用にArrayか確認する（Wappalyzerという拡張機能にて現象を確認）
          if (Array.isArray(e.data)) {
            this.model.userBuyerCodeList = e.data;
            if (!PlessViewUtilsSub.isEmptyArray(this.model.userBuyerCodeList)) {
              this.initSettings();
            }
          }
        });
      });
    }
  }

  /**
   * ビュー初期化
   *
   * @memberof KYMW1200Component
   */
  public ngAfterViewInit(): void {
    // 他媒体選択クリア処理
    this.cmbs.changes.subscribe(e => {
      e.forEach(_c => _c.registerOnTouched(() => this.clearOtherMediums()));
    });

    // 表示列設定用のパラメータ
    this.columnPicker = new wjInput.MultiSelect('#columnPicker', {
      itemsSource: this.dtg_Main.columns.filter(c => isNaN(Number(c.header))),  // 企画回以外が対象となる
      checkedMemberPath: 'visible',
      displayMemberPath: 'header',
      showSelectAllCheckbox: true,
      placeholder: '表示列設定',
      headerFormat: '表示列設定',
    });
    document.addEventListener('mousedown', (e) => {
      if (hasClass(<Element>e.target, 'column-picker')) {
        let host = this.columnPicker.hostElement;
        if (!host.offsetHeight) {
          showPopup(host, this.columnPicker, false, true, false);
          this.columnPicker.focus();
        } else {
          hidePopup(host, true, true);
          this.dtg_Main.focus();
        }
        e.preventDefault();
      }
    });
  }

  /**
   * コンポーネント破棄
   *
   * @memberof KYMW1200Component
   */
  ngOnDestroy() {
    if (this.subwindow) this.subwindow.close();
  }

  /**
   * ボタン押下 表示
   *
   * @memberof KYMW1200Component
   */
  public display() {
    if (
      this.isEditMode &&
      (this.model.updateItemInfosPerItem.length > 0 ||
        this.model.updateItemInfosPerCatalog.length > 0)
    ) {
      // 変更確認
      this.dialogService.openAlertGetMessage('Q0171', [], _c => {
        if (_c === PlessAlert.Yes) {
          this.saveProc(false);
        } else {
          this.model.revertItemListChanges();
          this.displayProc();
        }
      });
    } else {
      this.displayProc();
    }
  }

  /**
   * ボタン押下 選定済商品数一覧表示
   *
   * @memberof KYMW1200Component
   */
  public openSelectedList() {
    const openModal = () => {
      const kymw2000InputVO: KYMW2000InputModel = {
        funcID: 'KYMW1200',
        mediumType: this.model.mediumType,
        orderCode: '',
      };
      const kymw2000ComponentRef = this.dialogService.openModal(KYMW2000Component);
      const kymw2000Instance = kymw2000ComponentRef.componentInstance as KYMW2000Component;
      kymw2000Instance.parent = this;
      kymw2000Instance.setParams(kymw2000InputVO);
      kymw2000Instance.closeFunction = () => {
        kymw2000ComponentRef.close();
      };
    }
    
    if (
      this.isEditMode &&
      (this.model.updateItemInfosPerItem.length > 0 ||
        this.model.updateItemInfosPerCatalog.length > 0)
    ) {
      // 変更確認
      this.dialogService.openAlertGetMessage('Q0171', [], _c => {
        if (_c === PlessAlert.Yes) {
          this.saveProc(false);
          openModal();
        } else {
          this.model.revertItemListChanges();
          openModal();
        }
      });
    } else {
      openModal();
    }
  }

  /**
   * ボタン押下 過去サイクル確認
   *
   * @memberof KYMW1200Component
   */
  public openPastCycle() {
    if (this.subwindow && !this.subwindow.closed) return;

    if (
      this.isEditMode &&
      (this.model.updateItemInfosPerItem.length > 0 ||
        this.model.updateItemInfosPerCatalog.length > 0)
    ) {
      // 変更確認
      this.dialogService.openAlertGetMessage('Q0171', [], _c => {
        if (_c === PlessAlert.Yes) {
          this.saveProc(false);
          this.procSubwindow();
        } else {
          this.model.revertItemListChanges();
          this.procSubwindow();
        }
      });
    } else {
      this.procSubwindow();
    }
  }

  /**
   * ボタン押下 更新
   *
   * @memberof KYMW1200Component
   */
  public updateSummary() {
    if (this.model.updateItemInfosPerCatalog.length < 1) {
      this.registWkResultListService.execute(this.model, () => {
        this.getCycleSummaryService.execute(this.model);
      });
    } else {
      this.registWkResultListService.execute(this.model, () => {
        this.getCycleSummaryService.execute(this.model, () => {
          this.getCycleSummaryDiffService.execute(this.model);
        });
      });
    }
  }

  /**
   * ボタン押下 保存
   *
   * @memberof KYMW1200Component
   */
  public save() {
    this.saveProc();
  }

  /**
   * ボタン押下 企画回別商品一覧表示
   *
   * @memberof KYMW1200Component
   */
  public openCatalogItemList() {
    if (PlessViewUtilsSub.isEmpty(this.model.radioOrderCode)) {
      this.dialogService.openAlertGetMessage('E0148', ['一覧表のヘッダーで企画回を']);
      return;
    }

    const route = () => {
      this.router.navigate(['/kymw/1201'], {
        queryParams: {
          orderCode: this.model.radioOrderCode,
          mediumType: this.model.searchedMediumType,
          buyerCode: this.model.buyerCode,
        },
      });
    };

    if (
      this.isEditMode &&
      (this.model.updateItemInfosPerItem.length > 0 ||
        this.model.updateItemInfosPerCatalog.length > 0)
    ) {
      // 変更確認
      this.dialogService.openAlertGetMessage('Q0171', [], _c => {
        if (_c === PlessAlert.Yes) {
          this.saveProc(false, true);
          // 保持している変更を戻しておく（canDeactivateのため）
          this.model.revertItemListChanges();
          route();
        } else {
          this.model.revertItemListChanges();
          route();
        }
      });
    } else {
      route();
    }
  }

  /**
   * ボタン押下 ダウンロード
   *
   * @memberof KYMW1200Component
   */
  public download() {
    const output = () => {
      this.outputCycleItemInfoService.execute(this.model, () => {
        const fname =
          [
            KYMW1200Component.FILE_NAME_PREFIX,
            this.model.searchedMediumType,
            this.model.searchedBuyerCode,
            this.model.searchedCoopCode,
            PlessViewUtilsSub.formatedNowDate('YYYYMMDD_hhmmss'),
          ].join(KYMW1200Component.FILE_NAME_DELIMITER) +
          KYMW1200Component.FILE_NAME_SUFFIX;
        this.fileDownloadConfirmService.show(this.model.outputPath, fname);
      });
    };

    if (
      this.isEditMode &&
      (this.model.updateItemInfosPerItem.length > 0 ||
        this.model.updateItemInfosPerCatalog.length > 0)
    ) {
      // 変更確認
      this.dialogService.openAlertGetMessage('Q0171', [], _c => {
        if (_c === PlessAlert.Yes) {
          this.saveProc(false);
          output();
        } else {
          this.model.revertItemListChanges();
          output();
        }
      });
    } else {
      output();
    }
  }

  /**
   * コンテキストメニュー 一括設定
   *
   * @memberof KYMW1200Component
   */
  public bulkSet() {
    const openModal = () => {
      const componentRef = this.dialogService.openModal(KYMW1203Component);
      const instance = componentRef.componentInstance as KYMW1203Component;
      instance.parent = this;
      instance.setParams(this.model.kymw1203in);
      instance.closeFunction = () => {
        componentRef.close();
        const out = instance.getParams();
        if (out) {
          const item = this.model.itemList.find(
            _i => out.mediumType === _i.mediumType && out.pcode === _i.pcode
          );
          if (!item) return;
          out.orderCodeList.forEach(_o => {
            if (
              this.checkEditable(item.mediumType, item.pcode, _o) &&
              item.catalogInfoMap[_o] &&
              '9' !== item.catalogInfoMap[_o].pricePattern
            ) {
              item.catalogInfoMap[_o].pricePattern = out.pricePattern;
            }
          });
        }
      };
    };
    openModal();
  }

  /**
   * コンテキストメニュー 商品マスタ画面を開く
   *
   * @memberof KYMW1200Component
   */
  public openMaster() {
    if (!(this.dtg_Main.selectedItems[0] instanceof ItemInfo)) return;
    const selItem = this.dtg_Main.selectedItems[0];
    const open = () => {
      const componentRef = this.dialogService.openModal(KYMW1100Component);
      const instance = componentRef.componentInstance as KYMW1100Component;
      instance.setParams({ pCode: selItem.pcode });
      instance.dispDialog = true;
      instance.parent = this;
      instance.closeFunction = () => {
        componentRef.close();
        const out = instance.getParams();
        if (out && out.procDone) {
          this.displayProc(true);
        }
      };
    };

    if (
      this.isEditMode &&
      (this.model.updateItemInfosPerItem.length > 0 ||
        this.model.updateItemInfosPerCatalog.length > 0)
    ) {
      // 変更確認
      this.dialogService.openAlertGetMessage('Q0171', [], _c => {
        if (_c === PlessAlert.Yes) {
          this.saveProc(false);
          open();
        } else {
          this.model.revertItemListChanges();
          open();
        }
      });
    } else {
      open();
    }
  }

  /**
   * コンテキストメニュー 実績履歴画面を開く
   *
   * @memberof KYMW1200Component
   */
  public openResult() {
    if (!(this.dtg_Main.selectedItems[0] instanceof ItemInfo)) return;
    const selItem = this.dtg_Main.selectedItems[0];
    // 実績履歴画面(モーダル)を表示する。
    const componentRef = this.dialogService.openModal(KYMW0800Component);
    const instance = componentRef.componentInstance as KYMW0800Component;
    instance.parent = this;
    const input = new KYMW0800InputModel();
    input.funcID = 'KYMW1200';
    input.pCodeList = [
      {
        PCode: PlessViewUtilsSub.escapeXML(selItem.pcode),
        GuideGoodsName: PlessViewUtilsSub.escapeXML(selItem.goodsName),
        GuideStandardName: PlessViewUtilsSub.escapeXML(selItem.standardName),
      },
    ];
    instance.setInterfaceParam(input);

    instance.closeFunction = ()=> {
      componentRef.close();
    }
  }

  /**
   * コンテキストメニュー 掲載媒体設定
   *
   * @memberof KYMW1200Component
   */
  public setMediums() {
    const openModal = () => {
      const componentRef = this.dialogService.openModal(KYMW1202Component);
      const instance = componentRef.componentInstance as KYMW1202Component;
      instance.parent = this;
      instance.setParams({ pCode: this.dtg_Main.selectedItems[0].pcode });
      instance.closeFunction = () => {
        componentRef.close();
        const out = instance.getParams();
        if (out && out.procDone) {
          this.displayProc(true);
        }
      };
    };
    if (
      this.isEditMode &&
      (this.model.updateItemInfosPerItem.length > 0 ||
        this.model.updateItemInfosPerCatalog.length > 0)
    ) {
      // 変更確認
      this.dialogService.openAlertGetMessage('Q0171', [], _c => {
        if (_c === PlessAlert.Yes) {
          this.saveProc(false);
          openModal();
        } else {
          this.model.revertItemListChanges();
          openModal();
        }
      });
    } else {
      openModal();
    }
  }

  /**
   * コンテキストメニュー 価格パターン設定
   *
   * @memberof KYMW1200Component
   */
  public setPricePattern(pricePattern: string) {
    if (!(this.dtg_Main.selectedItems[0] instanceof ItemInfo)) return;
    // 選択した行・列を取得
    const selRow = this.dtg_Main.selection.row;
    const selCol = this.dtg_Main.selection.col;
    // 選択したセルのヘッダー名を取得
    const selColName = this.dtg_Main.columns[selCol].header;
    // 価格パターン、企画回メモを格納
    this.dtg_Main.collectionView.items[selRow].catalogInfoMap[selColName].pricePattern = pricePattern;
  }

  /**
   * コンテキストメニュー メモ編集画面を開く
   *
   * @memberof KYMW1200Component
   */
  public openMemoEdit() {
    if (!(this.dtg_Main.selectedItems[0] instanceof ItemInfo)) return;
    // 選択した行・列を取得
    const selRow = this.dtg_Main.selection.row;
    const selCol = this.dtg_Main.selection.col;
    // 選択したセルのヘッダー名を取得
    const selColName = this.dtg_Main.columns[selCol].header;
    // 選択したセルの情報を取得
    const selectionItem = this.dtg_Main.collectionView.items[selRow].catalogInfoMap[selColName];

    const openMemo = () => {
      const componentRef = this.dialogService.openModal(KYMW1204Component);
      const instance = componentRef.componentInstance as KYMW1204Component;
      instance.parent = this;
      const input = new KYMW1204InputModel();
      input.pricePattern = selectionItem.pricePattern;
      input.catalogMemo = selectionItem.catalogMemo;
      input.copyCatalogMemoFlg = selectionItem.copyCatalogMemoFlg;
      // サイクル確定しているかどうか
      input.cycleFixedFlg = !selectionItem.enableEdit;
      instance.setInterfaceParam(input);

      instance.closeFunction = (output)=> {
        if (output) {
          // 企画回メモを格納
          this.dtg_Main.collectionView.items[selRow].catalogInfoMap[selColName].catalogMemo = output.catalogMemo;
          this.dtg_Main.collectionView.items[selRow].catalogInfoMap[selColName].copyCatalogMemoFlg = output.copyCatalogMemoFlg;
        }
        componentRef.close();
      }
    };

    if (selectionItem) {
      openMemo();
    }
  }

  /**
   * 保存 実処理
   * @param sameConditions 
   * @param beforeRoute kymw1201:企画回別商品一覧遷移前かどうかを判定
   * @returns 
   */
  private saveProc(sameConditions = true, beforeRoute?: boolean) {
    if (
      this.model.updateItemInfosPerItem.length < 1 &&
      this.model.updateItemInfosPerCatalog.length < 1
    ) {
      // 変更がなければソートのみ保存
      this.registCycleSortService.execute(this.model);
      this.displayProc(sameConditions);
      return;
    }
    this.registCycleItemInfoService.execute(this.model, () => {
      if (this.model.isBuyer) this.registCycleSortService.execute(this.model);
      // kymw1201遷移前の保存処理の場合：表示処理を行うと、kymw1201遷移後にも
      // 処理が続いてしまうため、以下処理をスキップ
      if(!beforeRoute) this.displayProc(sameConditions);
    });
  }

  /**
   * 表示 実処理
   *
   * @memberof KYMW1200Component
   */
  private displayProc(sameConditions = false) {
    if (sameConditions) {
      this.model.mediumType = this.model.searchedMediumType;
      this.model.buyerCode = this.model.searchedBuyerCode;
      this.model.coopCode = this.model.searchedCoopCode;
      this.model.switchType = this.model.searchedSwitchType;
      this.model.orderCodeFrom = this.model.searchedOrderCodeFrom;
      this.model.orderCodeTo = this.model.searchedOrderCodeTo;
    } else {
      // バリデーション
      const invalidItem = this.validationsForDisplay.find(_ =>
        _.invalid(this.model)
      );
      if (invalidItem) {
        this.dialogService.openAlertGetMessage(
          invalidItem.code,
          invalidItem.messages
        );
        return;
      }
      // 受注コードTO 指定なければFROMから52週を指定
      if (!this.model.orderCodeTo) {
        this.model.orderCodeTo = this.model.orderCodeList
          .filter(_ => this.model.orderCodeFrom <= _.OrderCode)
          .pop().OrderCode;
        const orderCodeList = this.model.orderCodeList.filter( _ =>
          this.model.orderCodeFrom <= _.OrderCode &&
          this.model.orderCodeTo >= _.OrderCode
        );
        if (
          orderCodeList.length >
          KYMW1200Component.ORDER_SPAN_MAX - 1
        )
          this.model.orderCodeTo =
            orderCodeList[
              KYMW1200Component.ORDER_SPAN_MAX - 1
            ].OrderCode;
      }
    }
    this.getGridData();
  }

  /**
   * 過去サイクル 実処理
   *
   * @memberof KYMW1200Component
   */
  private procSubwindow() {
    const swidth = screen.width;
    const sheight = screen.height;
    this.subwindow = window.open(
      window.location.origin +
        KYMW1200Component.SUBWINDOW_PATH +
        window.location.pathname,
      '_blank',
      'left=0, top=0, width=' + swidth + ', height=' + sheight
    );
    window.addEventListener('message', e => {
      if (
        window.location.origin === e.origin &&
        KYMW1200Component.SUBWINDOW_PATH + window.location.pathname === e.data
      ) {
        this.subwindow.postMessage(
          this.sharedModel,
          window.location.origin +
            KYMW1200Component.SUBWINDOW_PATH +
            window.location.pathname
        );
      }

      // 遷移元画面からバイヤーコードを取得
      if (e.data === 'buyerReady') {
        this.subwindow.postMessage(this.model.userBuyerCodeList, '*');
      }
    });
  }

  /**
   * 予実表 行ロード(サイズ設定)
   *
   * @memberof KYMW1200Component
   */
  public loadedRows(grid: WjTransposedGrid) {
    grid.columns.defaultSize = 150;
    grid.columns.forEach(_ => (_.size = 120));
  }

  /**
   * 価格パターン 記号取得
   *
   * @memberof KYMW1200Component
   */
  public getPricePatternShape(val: string) {
    const el = PRICE_PATTERN_LIST.find(_ => val === _.Code);
    if (el) return el.Name;
    return PRICE_PATTERN_LIST[0].Name;
  }

  /**
   * 価格パターン＋企画回メモ取得（画面表示用）
   * @param val 
   * @returns 
   */
  public getPricePatternAndCatalogMemo(val: any) {
    const pricePatternShape = this.getPricePatternShape(val.pricePattern);
    const retValue = pricePatternShape + val.catalogMemo;
    return retValue;
  }

  /**
   * 編集可否判定
   *
   * @memberof KYMW1200Component
   */
  public checkEditable(mtype: string, pcode: string, order: string): boolean {
    const item = this.model.itemList.find(
      _i => mtype === _i.mediumType && pcode === _i.pcode
    );
    if (!item || !item.catalogInfoMap[order]) return false;
    return (
      this.isEditMode && // 機能別権限 フルコントロール
      this.model.isPricePatternMode && // 表示情報切替 サイクル・価格パターン設定
      item.enableSet && // 設定可否フラグ (掲載媒体設定)
      item.catalogInfoMap[order].delivStartDate >= item.applyTermStart && // 取扱開始以降
      item.catalogInfoMap[order].delivStartDate < item.applyTermEnd && // 取扱終了より前
      (!KYMW1200Component.MEDIUM_LIST_TO_CHECK_OTHERS.includes(
        item.mediumType
      ) ||
        !item.catalogInfoMap[order].selectedOthers)
    );
  }

  /**
   * 他媒体選択 取得
   *
   * @memberof KYMW1200Component
   */
  public getOtherMediums(mtype: string, pcode: string, order: string) {
    if (!mtype) return;
    if (!pcode) return;
    if (!order) return;
    this.getOtherMediumsService.execute(mtype, pcode, order, this.model);
  }

  /**
   * 他媒体選択 クリア
   *
   * @memberof KYMW1200Component
   */
  public clearOtherMediums() {
    this.model.otherMediums = [];
  }

  /**
   * グリッドデータ取得
   *
   * @memberof KYMW1200Component
   */
  private getGridData() {
    this.model.radioOrderCode = '';
    // API リクエスト
    this.registWkResultListService.execute(this.model, () => {
      this.getCycleItemInfoService.execute(this.model, async () => {
        // 下記条件のいずれかに当てはまる場合、企画回ラジオボタンを非活性にする。
        // ・表示モードがバイヤー
        // ・媒体にALLが指定されている
        // ・表示生協にALL以外が指定されている
        if (this.model.isBuyer && (this.model.mediumType === KYMW1200Component.SELECT_ITEM_ALL_VALUE ||
          this.model.coopCode !== KYMW1200Component.SELECT_ITEM_ALL_VALUE)) {
          this.disableRadioOrderCode = true;
        } else {
          this.disableRadioOrderCode = false;
        }

        const cmap = this.model.itemList?.[0]?.catalogInfoMap;
        if (cmap) {
          // 確定していない最も古い企画回のラジオボタンが選択状態
          const orderList = Object.keys(cmap);
          let order = orderList.find(_o => {
            return this.model.itemList
              .map(_i => _i.catalogInfoMap?.[_o]?.status)
              .filter(_i => _i)
              .some(_i => CatalogInfo.STATUS_EDITABLE === _i);
          });

          // 確定していない企画回が存在しない場合は最新の企画回を選択
          if (PlessViewUtilsSub.isEmpty(order)) {
            orderList.sort();
            order = orderList[orderList.length - 1];
          }

          this.model.radioOrderCode = order;
        }
        this.registCycleDispConditionService.execute(this.model, () => {
          // 表示ボタン押下で表の幅を適用
          const vo = {
            userId: this.sharedModel.kymw1001Model.loginUserInfo.UserID,
            gridId: '1200'
          }
          this.getUserColumnWidthSettingsService.execute(vo, (data) => {
            this.setColumnWidthSettings(data?.ColumnInfo);
          })
        });
      });
    });
  }

  /**
   * 初期設定
   * 表示モード設定/コンテキストメニュー設定/初期表示処理
   *
   * @memberof KYMW1200Component
   */
  private async initSettings() {
    // 表示モード設定
    if (
      this.router.url.startsWith(KYMW1200Component.SUBWINDOW_PATH) &&
      this.model.userBuyerCodeList.length > 0
    ) {
      this.model.displayMode = KYMW1200Model.DISPLAY_MODE_PAST;
    } else if (this.model.userBuyerCodeList.length > 0) {
      this.model.displayMode = KYMW1200Model.DISPLAY_MODE_BUYER;
    } else if (
      this.sharedModel.kymw1001Model.loginUserInfo.UserClassList.find(
        _ => KYMW1200Component.USER_CLASS_LEADER === _.UserClass
      )
    ) {
      this.model.displayMode = KYMW1200Model.DISPLAY_MODE_LEADER;
      this.model.userLeaderClass =
        this.sharedModel.kymw1001Model.loginUserInfo.UserClassList.find(
          _ => KYMW1200Component.USER_CLASS_LEADER === _.UserClass
        ).ClassCode;
      this.model.userId = this.sharedModel.kymw1001Model.loginUserInfo.UserID;
    } else if (
      KYMW1200Component.ASSOCIATED_USER_TYPE_SUPPLIER ===
        this.sharedModel.kymw1001Model.loginUserInfo.AssociatedUserType &&
      this.sharedModel.kymw1001Model.loginUserInfo.SupplierCode
    ) {
      this.model.displayMode = KYMW1200Model.DISPLAY_MODE_SUPPLIER;
      this.model.userSupplierCode = this.sharedModel.kymw1001Model.loginUserInfo.SupplierCode;
    } else {
      this.model.displayMode = KYMW1200Model.DISPLAY_MODE_OTHERS;
    }

    // グリッド設定
    if (this.dtg_Main && (this.model.isBuyer || this.model.isPast)) {
      this.dtg_Main.headersVisibility = HeadersVisibility.All;
      this.dtg_Main.allowDragging = AllowDragging.Rows;
    } else if (this.dtg_Main) {
      this.dtg_Main.headersVisibility = HeadersVisibility.Column;
      this.dtg_Main.allowDragging = AllowDragging.None;
    }

    // コンテキストメニュー設定
    this.initMenu();

    // 保存条件設定/初期表示処理
    try {
      await this.getCycleMediumSelectItemsService.executeAsync(this.model);
      this.model.cycleMediumList.map(_ => (_.Name = _.Code + ':' + _.Name));
      this.model.cycleMediumList.unshift({
        Code: KYMW1200Component.SELECT_ITEM_ALL_VALUE,
        Name: KYMW1200Component.SELECT_ITEM_ALL_NAME,
      });
      await this.getCoopListService.executeAsync(this.model, 'coopList');
      this.model.coopList.map(
        _ => (_.CoopName = _.CoopCode + ':' + _.CoopName)
      );
      this.model.coopList.unshift({
        CoopCode: KYMW1200Component.SELECT_ITEM_ALL_VALUE,
        CoopName: KYMW1200Component.SELECT_ITEM_ALL_NAME,
        CoopShortName: null,
        PlanCoopName: null,
      });
      await this.getCodeListService.executeAsync(
        KYMW1200Component.SWITCH_TYPE_CODE_DIV,
        null,
        this.model,
        'switchTypeList'
      );
      await this.getOrderListService.executeAsync(this.model, 'orderCodeList');
      if (this.model.isLeader) {
        await this.getStaffBuyerSelectItemsService.executeAsync(this.model, this.model.userId);
      }
      await this.getBuyerSelectItemsService.executeAsync(this.model);
      await this.getCycleDispConditionService.executeAsync(this.model, (data) => {
        if (PlessViewUtilsSub.isEmpty(data)) { // getCycleDispConditionでデータを取得しなかった場合
          this.setInitData();
        }
      });
    } catch (e) { }
  }

  /**
   * 初期データ設定
   *
   * @memberof KYMW1200Component
   */
  private async setInitData() {
    this.model.coopCode = KYMW1200Component.SELECT_ITEM_ALL_VALUE;
    this.model.switchType = KYMW1200Model.PRICE_PATTERN_TYPE;
    try {
      await this.getNonFixedOrderListService.executeAsync(this.model);
      if (this.model.nonFixedOrderCodeList?.length > 0) {
        this.model.orderCodeFrom =
          this.model.nonFixedOrderCodeList[0].OrderCode;
        this.model.orderCodeTo =
          this.model.nonFixedOrderCodeList.pop().OrderCode;
      }
      if (
        this.model.nonFixedOrderCodeList?.length >
        KYMW1200Component.INIT_ORDER_TO_INDEX
      )
        this.model.orderCodeTo =
          this.model.nonFixedOrderCodeList[
            KYMW1200Component.INIT_ORDER_TO_INDEX
          ].OrderCode;
    } catch (e) {}
  }

  /**
   * コンテキストメニュー 設定
   *
   * @memberof KYMW1200Component
   */
  private initMenu() {
    if (this.model.isBuyer) {
      this.context = new Menu(document.createElement('div'), {
        displayMemberPath: 'caption',
        selectedValuePath: 'cmd',
        itemsSource: [
          { caption: '&#9675;', cmd: 'setPricePattern0', withOrder: false, enabled: true},
          { caption: '&#9651;', cmd: 'setPricePattern1', withOrder: false, enabled: true},
          { caption: '&#9633;', cmd: 'setPricePattern2', withOrder: false, enabled: true},
          { caption: '&#9734;', cmd: 'setPricePattern3', withOrder: false, enabled: true},
          { caption: '&minus;', cmd: 'setPricePattern9', withOrder: false, enabled: true},
          { caption: '&nbsp;', cmd: 'setPricePatternEmpty', withOrder: false, enabled: true},
          { caption: '-'},
          { caption: 'メモを編集する',
            cmd: 'openMemoEdit',
            withOrder: false,
            enabled: true
          },
          { caption: '-'},
          { caption: '一括設定', cmd: 'bulkSet', withOrder: true, enabled: true },
          {
            caption: '商品マスタ画面を開く',
            cmd: 'openMaster',
            withOrder: false,
            enabled: true
          },
          {
            caption: '実績履歴画面を開く',
            cmd: 'openResult',
            withOrder: false,
            enabled: true
          },
          { caption: '掲載媒体設定', cmd: 'setMediums', withOrder: false, enabled: true},
          { caption: '-'},
          { caption: '最上部に移動', cmd: 'moveToTop', withOrder: false, enabled: true},
          { caption: '最下部に移動', cmd: 'moveToBottom', withOrder: false, enabled: true},
          { caption: '指定するPコードの下に移動', cmd: 'moveToBelowPcode', withOrder: false, enabled: true},
        ],
        command: {
          canExecuteCommand: param => {
            if (param.withOrder) return this.model.kymw1203in ? true : false;
            if ('setMediums' === param.cmd) return this.isPermittedFullControl;
            // フィルターがかかっているかチェック。かかっている場合は行移動ができないようにする
            const filterFlg = JSON.parse(this.fltr_Main.filterDefinition).filters.length > 0;
            if (filterFlg && 'moveToTop' === param.cmd) return false;
            if (filterFlg && 'moveToBottom' === param.cmd) return false;
            if (filterFlg && 'moveToBelowPcode' === param.cmd) return false;
            if (!param.enabled) {
              return false;
            }
            return true;
          },
        },
        itemClicked: () => {
          if (this.context.selectedValue === 'bulkSet') this.bulkSet();
          if (this.context.selectedValue === 'openMaster') this.openMaster();
          if (this.context.selectedValue === 'openResult') this.openResult();
          if (this.context.selectedValue === 'setMediums') this.setMediums();
          if (this.context.selectedValue === 'setPricePattern0') this.setPricePattern('0');
          if (this.context.selectedValue === 'setPricePattern1') this.setPricePattern('1');
          if (this.context.selectedValue === 'setPricePattern2') this.setPricePattern('2');
          if (this.context.selectedValue === 'setPricePattern3') this.setPricePattern('3');
          if (this.context.selectedValue === 'setPricePattern9') this.setPricePattern('9');
          if (this.context.selectedValue === 'setPricePatternEmpty') this.setPricePattern('');
          if (this.context.selectedValue === 'openMemoEdit') this.openMemoEdit();
          if (this.context.selectedValue === 'moveToTop') this.moveToTop();
          if (this.context.selectedValue === 'moveToBottom') this.moveToBottom();
          if (this.context.selectedValue === 'moveToBelowPcode') this.moveToBelowPcode();
        },
      });
    } else if (
      this.model.isLeader ||
      this.model.isOthers
    ) {
      this.context = new Menu(document.createElement('div'), {
        displayMemberPath: 'caption',
        selectedValuePath: 'cmd',
        itemsSource: [
          { caption: '&#9675;', cmd: 'setPricePattern0', enabled: true},
          { caption: '&#9651;', cmd: 'setPricePattern1', enabled: true},
          { caption: '&#9633;', cmd: 'setPricePattern2', enabled: true},
          { caption: '&#9734;', cmd: 'setPricePattern3', enabled: true},
          { caption: '&minus;', cmd: 'setPricePattern9', enabled: true},
          { caption: '&nbsp;', cmd: 'setPricePatternEmpty', enabled: true},
          { caption: '-'},
          { caption: 'メモを編集する',
            cmd: 'openMemoEdit',
            enabled: true
          },
          { caption: '-'},
          {
            caption: '商品マスタ画面を開く',
            cmd: 'openMaster',
            enabled: true
          },
          {
            caption: '実績履歴画面を開く',
            cmd: 'openResult',
            enabled: true
          },
        ],
        command: {
          canExecuteCommand: param => {
            if (!param.enabled) {
              return false;
            }
            return true;
          },
        },
        itemClicked: () => {
          if (this.context.selectedValue === 'openMaster') this.openMaster();
          if (this.context.selectedValue === 'openResult') this.openResult();
          if (this.context.selectedValue === 'setPricePattern0') this.setPricePattern('0');
          if (this.context.selectedValue === 'setPricePattern1') this.setPricePattern('1');
          if (this.context.selectedValue === 'setPricePattern2') this.setPricePattern('2');
          if (this.context.selectedValue === 'setPricePattern3') this.setPricePattern('3');
          if (this.context.selectedValue === 'setPricePattern9') this.setPricePattern('9');
          if (this.context.selectedValue === 'setPricePatternEmpty') this.setPricePattern('');
          if (this.context.selectedValue === 'openMemoEdit') this.openMemoEdit();
        },
      });
    }
  }

  /**
   * 行入れ替え処理
   *
   * @memberof KYMW1200Component
   */
  public onDraggingRow(s: FlexGrid, e: CellRangeEventArgs) {
    this.dragIndex = e.row;
    s.collectionView.moveCurrentToPosition(this.dragIndex);
  }

  /**
   * 行入れ替え処理
   *
   * @memberof KYMW1200Component
   */
  public onDraggedRow(s: FlexGrid, e: CellRangeEventArgs) {
    let dropIndex = e.row,
      arr = s.collectionView.sourceCollection;
    s.collectionView.deferUpdate(() => {
      let item = arr[this.dragIndex];
      arr.splice(this.dragIndex, 1);
      arr.splice(dropIndex, 0, item);
      s.collectionView.moveCurrentToPosition(dropIndex);
    });
  }

  /** 予実グリッド初期処理 */
  public initSummary(g: FlexGrid) {
    g.itemFormatter = (panel, r, c, cell) => {
      // 列ごとの配色
      if (CellType.Cell === panel.cellType && c % 2 === 1)
        cell.classList.add('even-column');
      // ヘッダー セレクトリスト埋め込み
      if (CellType.RowHeader === panel.cellType && r === 5) {
        cell.childNodes.forEach(_ => cell.removeChild(_));
        cell.classList.add('header-cell');
        const sel = document.createElement('select');
        sel.setAttribute('class', 'header-select');
        sel.addEventListener('change', () => {
          this.model.summaryList.forEach(_ => (_.switchType = sel.value));
          g.collectionView.refresh();
        });
        KYMW1200Component.HEADER_SELECT_ITEMS.forEach(_ => {
          const op = document.createElement('option');
          op.setAttribute('value', _.val);
          op.innerText = _.dsp;
          sel.appendChild(op);
        });
        sel.selectedIndex = Number(this.model.summaryList[0]?.switchType);
        cell.appendChild(sel);
      }
    };
  }

  /** 一覧グリッド初期処理 */
  public initMain(g: FlexGrid) {
    if (this.model.isBuyer || this.model.isPast) {
      g.headersVisibility = HeadersVisibility.All;
      g.allowDragging = AllowDragging.Rows;
    } else {
      g.headersVisibility = HeadersVisibility.Column;
      g.allowDragging = AllowDragging.None;
    }
    g.allowMerging = AllowMerging.AllHeaders;
    g.columnHeaders.rows.insert(0, new Row());
    g.columns.forEach((_, i) => {
      g.columnHeaders.setCellData(0, i, _.header);
      g.columnHeaders.columns[i].allowMerging = true;
    });
    g.frozenColumns = 19;
    g.itemFormatter = (panel, r, c, cell) => {
      // 企画回情報 ヘッダー配色
      if (
        CellType.ColumnHeader === panel.cellType &&
        c > KYMW1200Component.CATALOG_FRONT_COLS &&
        c < panel.columns.length - KYMW1200Component.CATALOG_BACK_COLS
      ) {
        const oCode =
          this.model.filteredOrderList.find(
            (_, i) => i === c - KYMW1200Component.CATALOG_FRONT_COLS - 1
          )?.OrderCode ?? '';
        const li = this.model.itemList
          .map(_ => _.catalogInfoMap?.[oCode]?.status)
          .filter(_ => _);
        if (
          oCode &&
          li.length > 0 &&
          li.every(_ => CatalogInfo.STATUS_PLAN_FIXED === _)
        ) {
          cell.classList.add('order-head-fixed');
        } else if (
          oCode &&
          li.length > 0 &&
          li.every(
            _ =>
              CatalogInfo.STATUS_PLAN_FIXED === _ ||
              CatalogInfo.STATUS_CYCLE_FIXED === _
          )
        ) {
          cell.classList.add('order-head-cycle-fixed');
        } else {
          cell.classList.add('order-head');
        }
      }
      // 企画回情報 セル配色
      if (
        CellType.Cell === panel.cellType &&
        c > KYMW1200Component.CATALOG_FRONT_COLS &&
        c < panel.columns.length - KYMW1200Component.CATALOG_BACK_COLS
      ) {
        const oCode =
          this.model.filteredOrderList.find(
            (_, i) => i === c - KYMW1200Component.CATALOG_FRONT_COLS - 1
          )?.OrderCode ?? '';
        // フィルタ後にもセル配色が適用されるようにするため、
        // gridのitemsSource（itemList）ではなくフィルタ後の表示データに対してセル配色を適用する
        // フィルタ後の表示データ（初期表示はフィルタなし）：this.fltr_Main.grid.collectionView.items
        const cInfo = this.fltr_Main.grid.collectionView.items.find((_, i) => r === i)
          ?.catalogInfoMap?.[oCode];

        if (
          cInfo &&
          KYMW1200Component.REGEX_FEATURE_COVER.test(cInfo.featureCode)
        )
          cell.classList.add('order-cell-h1');
        if (
          cInfo &&
          KYMW1200Component.REGEX_FEATURE_BACK_COVER.test(cInfo.featureCode)
        )
          cell.classList.add('order-cell-h2');
        if (cInfo?.featureCode) cell.classList.add('order-cell');
        if (!this.model.isPricePatternMode && cInfo?.isSpecialPrice)
          cell.classList.add('special-value-cell');
      }
    };
    g.itemsSourceChanged.addHandler((_g: FlexGrid, _e: EventArgs) => {
      _g.select(-1, -1);
    });
    g.hostElement.addEventListener('contextmenu', e => {
      e.preventDefault();
      if (!this.model.searchedMediumType) return;
      this.model.kymw1203in = null;
      const ht = g.hitTest(e.pageX, e.pageY);
      g.select(new CellRange(ht.row, ht.col), false);
      if (
        ht.cellType === CellType.Cell &&
        g.selectedItems[0] instanceof ItemInfo
      ) {
        const oCode =
          this.model.filteredOrderList.find(
            (_, i) => i === ht.col - KYMW1200Component.CATALOG_FRONT_COLS - 1
          )?.OrderCode ?? '';
        const item = g.selectedItems[0];
        if (
          oCode &&
          item &&
          this.checkEditable(item.mediumType, item.pcode, oCode)
        )
          this.model.kymw1203in = {
            mediumType: item.mediumType,
            pcode: item.pcode,
            orderCodeFrom: oCode,
            orderCodeTo: this.model.searchedOrderCodeTo,
          };
      }
      // 編集可能時、コンテキストメニュー「メモを編集する」を活性とする
      this.eventContextMenu_Handler(ht.col, g.selectedItems[0]);
      if (this.context) DataGridUtil.showContextMenu(g, this.context, e);
    });
    // フィルタ 設定
    if (this.fltr_Main) {
      this.fltr_Main.defaultFilterType = FilterType.Both;
      this.fltr_Main.showSortButtons = false;
      this.fltr_Main.filterChanged.addHandler(
        (f: FlexGridFilter, e: EventArgs) => {
          const activeFilter = f.grid.columns.find(
            _ => f.getColumnFilter(_).isActive
          );
          if ((this.model.isBuyer || this.model.isPast) && !activeFilter) {
            g.allowDragging = AllowDragging.Rows;
          } else {
            g.allowDragging = AllowDragging.None;
          }
        }
      );
    }

    this.dtg_Main.rowHeaders.columns[0].minWidth = 5;
  }

  /** 固定列のサイズ変更で発生する動作不備を解消するためのメソッド */
  fixFrozenColumns(wrapper: any): void {
    const grid: FlexGrid =
      wrapper && wrapper.control ? wrapper.control : wrapper;
    if (!grid) return;

    let downX = 0;
    let drag: { col: number; startWidth: number; desired?: number } | null =
      null;
    let onUp: ((e: MouseEvent) => void) | null = null;

    const host: HTMLElement = (grid as any).hostElement;
    host.addEventListener(
      'mousedown',
      (e: MouseEvent) => {
        drag = null;
        downX = e.pageX;
        onUp = (ev: MouseEvent) => {
          if (drag) {
            const col = grid.columns.getColumn(drag.col);
            drag.desired = Math.max(
              col.minWidth || 0,
              Math.round(drag.startWidth + (ev.pageX - downX))
            );
          }
          window.removeEventListener('mouseup', onUp!, true);
          onUp = null;
        };
        window.addEventListener('mouseup', onUp, true);
      },
      true
    );

    grid.resizingColumn.addHandler((s: FlexGrid, e: CellRangeEventArgs) => {
      if (e.panel !== s.cells || !s.columns.isFrozen(e.col)) return;
      if (!drag) {
        drag = {
          col: e.col,
          startWidth: s.columns.getColumn(e.col).renderWidth,
        };
      }
      const data = (e as any).data;
      if (data && data.maxSize != null) {
        data.maxSize = null;
      }
    });

    grid.resizedColumn.addHandler((s: FlexGrid, e: CellRangeEventArgs) => {
      if (e.panel !== s.cells || !drag || e.col !== drag.col) return;
      const d = drag;
      queueMicrotask(() => {
        if (d.desired == null) return;
        const col = s.columns.getColumn(d.col);
        if (col.width !== d.desired) {
          col.width = d.desired;
        }
      });
    });
  }

  /** 編集ユーザ判定 (バイヤーかつ権限有り) */
  get isEditUser() {
    return (
      this.model.isBuyer &&
      this.sharedModel.FUNC_PERMISSION_FULLCONTROL === this.getFuncPermission()
    );
  }

  /** 編集モード判定 (バイヤーかつ権限有りかつ検索条件有効) */
  get isEditMode() {
    return (
      this.model.isBuyer &&
      KYMW1200Component.SELECT_ITEM_ALL_VALUE !==
        this.model.searchedMediumType &&
      KYMW1200Component.SELECT_ITEM_ALL_VALUE === this.model.searchedCoopCode &&
      this.sharedModel.FUNC_PERMISSION_FULLCONTROL === this.getFuncPermission()
    );
  }

  /** 分類タグ 変更イベント */
  public eventCategoryTagId_CHANGEHandler(item: any): void {
    if (item.categoryTagId === 'blankVal') item.categoryTagId = '';
  }

  /** グリッドのカラム幅・表示カラム保存 */
  public saveColumnWidthSettings(): void {
    // 列幅設定登録
    // リクエスト用VO作成
    const vo = {
      userId: this.sharedModel.kymw1001Model.loginUserInfo.UserID,
      gridId: '1200',
    };
    this.registUserColumnWidthSettingsService.execute(vo, this.dtg_Main, null);
  }

  /** グリッドのカラム幅をセット */
  public setColumnWidthSettings(columnInfo: any): void {
    if (!PlessViewUtilsSub.isEmptyArray(columnInfo)) {
      // カラム名と幅の数値をそれぞれパラメータとするリスト
      const columnList = Object.keys(columnInfo).map(key => ({
        header: key,
        width: columnInfo[key].width,
        displayFlg: columnInfo[key].displayFlg
      }));
      // 表のカラムごとに幅の数値を設定する
      this.dtg_Main.columns.map(column => {
        // 改行しているヘッダーは改行を外した文字列で判定
        const headerName = column.header?.replace("\n", "");
        const targetData = columnList.find(w => w.header === headerName);
        // 幅の数値
        const targetWidth = targetData?.width;
        // 表示フラグ
        const targetDisplayFlg = targetData?.displayFlg;
        if (targetWidth) {
          // 幅の数値があればwidthに設定
          column.width = Number(targetWidth);
        }
        if (targetDisplayFlg) {
          const flg = targetDisplayFlg === '1';
          // 表示フラグがあればvisibleに設定
          column.visible = flg;
          // チェック状態反映
          // ※itemsSourceに含まれている列かチェック
          const targetHeader = this.columnPicker.itemsSource.find(item => item.header === column.header);
          if (targetHeader) {
            targetHeader.visible = flg;
          }
        }
      })
      // チェック状態を更新（非表示カラムを除外）
      this.columnPicker.checkedItems = this.columnPicker.itemsSource.filter(item => item.visible);
      this.columnPicker.onCheckedItemsChanged();
    }
  }

  /**
   * コンテキストメニューの活性非活性制御
   * @param c カラム
   * @param item 選択したアイテム
   */
  public eventContextMenu_Handler(c: any, item): void {
    if (this.context) {
      // 受注コード取得
      const oCode =
        this.model.filteredOrderList.find(
          (_, i) => i === c - KYMW1200Component.CATALOG_FRONT_COLS - 1
        )?.OrderCode ?? '';
      // 編集可否フラグ
      const flg = this.checkEditable(item.mediumType, item.pcode, oCode);

      // 選択した行・列を取得
      const selCol = this.dtg_Main.selection.col;
      // 選択したセルのヘッダー名を取得
      const selColName = this.dtg_Main.columns[selCol].header;
      // 選択したセルの情報を取得
      const selectionItem = item.catalogInfoMap[selColName];
      // サイクル未確定フラグ（企画回以外を選択された場合はfalse）
      const cycleNonFixedFlg = selectionItem ? selectionItem.enableEdit : false;

      this.context.itemsSource.forEach(item => {
        if (item.cmd === 'openMemoEdit') {
          // 「メモを編集する」の活性制御
          if (!PlessViewUtilsSub.isEmpty(oCode) && flg) {
            // 企画回を選択かつ、編集可能の場合、活性
            item.enabled = this.setContextMenuEnabled(item, true);
          } else {
            // 上記以外の場合、非活性
            item.enabled = this.setContextMenuEnabled(item, false);
          }
        }

        if (item.cmd === 'setPricePattern0'
          || item.cmd === 'setPricePattern1'
          || item.cmd === 'setPricePattern2'
          || item.cmd === 'setPricePattern3'
          || item.cmd === 'setPricePattern9'
          || item.cmd === 'setPricePatternEmpty') {
          // 価格パターンの活性制御
          item.enabled = this.setContextMenuEnabled(item, cycleNonFixedFlg);
        }
      });
    }
  }
  
  /**
   * 選択した行を最上部に移動
   */
  public moveToTop(): void {
    // 行移動
    this.moveRowHandler(0);
  }

  /**
   * 選択した行を最下部に移動
   */
  public moveToBottom(): void {
    // 最下部の行インデックス
    const bottomRow = this.dtg_Main.rows.length - 1;
    // 行移動
    this.moveRowHandler(bottomRow);
  }

  /**
   * 選択した行を指定するPコードを持つデータの下に移動
   * モーダルを開き、Pコードを入力する
   */
  public moveToBelowPcode(): void {
    if (!(this.dtg_Main.selectedItems[0] instanceof ItemInfo)) return;
    // 選択した行
    const selectRow = this.dtg_Main.selection.row;
    // 最上部のPコード
    const topPCode = this.dtg_Main.collectionView.items[0].pcode;
    // 最下部のPコード
    const bottomPCode = this.dtg_Main.collectionView.items[this.dtg_Main.rows.length - 1].pcode;

    // Pコード指定画面を表示する。
    const componentRef = this.dialogService.openModal(KYMW1205Component);
    const instance = componentRef.componentInstance as KYMW1205Component;
    instance.parent = this;

    instance.closeFunction = (output)=> {
      if (output) {
        // 指定されたPコードが表の中にあるのかチェック
        const outputPCode = this.dtg_Main.collectionView.items.find(item => item.pcode === output.pCode)?.pcode;

        // 表の中にあるPコードであれば、選択した行をその下に移動する
        let targetRow = 0;
        if (outputPCode) {
          // 指定されたPコードの行インデックスを取得
          const outputRow = this.dtg_Main.collectionView.items.findIndex(item => item.pcode === outputPCode);
          if (selectRow === outputRow) {
            // 選択したPコードと同じPコードが指定されている場合、エラーを表示し再入力を促す
            this.dialogService.openAlertGetMessage('E0578', ['選択しているPコード']);
            return;
          } else {
            if (outputPCode === topPCode) {
              // 最上部のPコードが指定されている場合
              targetRow = 1;
            } else if (outputPCode === bottomPCode) {
              // 最下部のPコードが指定されている場合
              targetRow = this.dtg_Main.rows.length - 1;
            } else {
              // それ以外のPコードが指定されている場合
              if (selectRow > outputRow) {
                // 選択したPコードよりも前のPコードが指定されている場合
                targetRow = this.dtg_Main.collectionView.items.findIndex(item => item.pcode === outputPCode) + 1;
              } else if (selectRow < outputRow) {
                // 選択したPコードよりも後のPコードが指定されている場合
                targetRow = this.dtg_Main.collectionView.items.findIndex(item => item.pcode === outputPCode);
              }
            }
            // 行移動
            this.moveRowHandler(targetRow);
          }
        } else {
          // 指定されたPコードが表の中にない場合、エラーを表示し再入力を促す
          this.dialogService.openAlertGetMessage('E0667', ['入力されたPコード', '正しいPコード']);
          return;
        }
      }
      componentRef.close();
    }
  }

  /**
   * コンテキストメニュークリックで行移動するときの共通メソッド
   * @param targetRow 移動先の行
   */
  public moveRowHandler(targetRow: number): void {
    // 選択行
    const selectRow = this.dtg_Main.selection.row;
    // ドラッグ時と同じ処理で行を移動
    const arr = this.dtg_Main.collectionView.sourceCollection;
    this.dtg_Main.collectionView.deferUpdate(() => {
      let item = arr[selectRow];
      arr.splice(selectRow, 1);
      arr.splice(targetRow, 0, item);

      // 選択行を更新するためsetTimeOutを使用
      setTimeout(() => {
        // 移動
        this.dtg_Main.collectionView.moveCurrentToPosition(targetRow);
        // 画面に選択行が表示されていない場合は表をスクロールして表示
        const rc = this.dtg_Main.cells.getCellBoundingRect(this.dtg_Main.selection.row, 0, true);
        this.dtg_Main.scrollPosition = new Point(0, -rc.top);
      });
    })
  }

  /**
   * ディアクティベート処理
   */
  public canDeactivate(): CanDeactivateType {
    const result = new Subject<boolean>();

    // 「閲覧モードではない」かつ「内容が変更されている」時は確認メッセージを表示
    if (this.isEditMode &&
      (this.model.updateItemInfosPerItem.length > 0 ||
        this.model.updateItemInfosPerCatalog.length > 0)) {
      this.dialogService.openAlertGetMessage(
        'Q0107', ['サイクル情報'],
        (closeDetail: any): void => {
          if (closeDetail === PlessAlert.Yes) {
            result.next(true);
          } else {
            result.next(false);
          }
        });
      return result;
    } else {
      return true;
    }
  }
}
